import React from "react";
import styled from "styled-components";

import { Button, VSpace } from "@examspark/common-ui";
import { IconRefreshLine } from "@examspark/common-ui/dist/components/icons";
import { ExamConfigData } from "@examspark/types";

const Styled = styled.div`
  text-align: center;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5rem;
`;

const H1 = styled.h1`
  font-weight: bold;
  font-size: 2rem;
  color: #333;
`;
const H2 = styled.h2`
  font-weight: normal;
  font-size: 1.4rem;
  color: #666;
`;

const NoResults = (props: {
  config?: ExamConfigData;
  onRequestRetake?: () => void;
}) => {
  return (
    <div style={{ flex: 1 }}>
      <Styled>
        <VSpace style={{ gap: "0.5rem" }}>
          <H1>Your work has been submitted.</H1>
          <H2>You may safely close this window.</H2>
          {props.config?.allowRetakes && (
            <Button
              title="Retake Activity"
              variant="outlined"
              icon={<IconRefreshLine />}
              onClick={props.onRequestRetake}
            >
              Retake Actvivity
            </Button>
          )}
        </VSpace>
      </Styled>
    </div>
  );
};

export default NoResults;
